import { VariaveisAmbiente } from "ambiente";

export const GetAuthCallbackUrl = (rota: string) => {
  const urlAtual = new URL(window.location.href);
  const novaUrlCallback = new URL(urlAtual.origin + '/api/v4/autenticar/');
  novaUrlCallback.searchParams.set('token', '@token');
  if (rota.length > 0) {
    novaUrlCallback.searchParams.set('rota', rota);
  }
  return btoa(novaUrlCallback.href.replace(/%40/gi, '@'));
};
export const GetAuthADMRedirect = (empresaId: string) => {
  let url = 'https://app.minhaloja.vip';
  if (VariaveisAmbiente.isDev) {
    url = 'https://app-dev.minhaloja.vip'
  }
  return `${url}/login?callbackUrl=${btoa(`${window.location.origin}/{empresaId}/login/{accessToken}`)}&empresaId=${empresaId}`;
}

export const GetAuthLoginRedirect = () => {
  let url = 'https://app.minhaloja.vip';
  let urlCallback = window.location.origin;
  if (VariaveisAmbiente.isDev) {
    url = 'https://app-dev.minhaloja.vip'
  }
  return `${url}/login?callbackUrl=${btoa(`${urlCallback}/{empresaId}/login/{accessToken}`)}`;
}
